import classNames from 'classnames';
import type { ChangeEvent, FC, SelectHTMLAttributes } from 'react';
import { memo } from 'react';
import type { MessageDescriptor } from 'react-intl';
import { useIntl } from 'react-intl';

export type SelectPropOption = {
  label: string | MessageDescriptor;
  value: string | number | undefined;
  disabled?: boolean;
};

export interface SelectPropTypes extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  error?: Error | string;
  value?: string | number;
  options: SelectPropOption[];
  className?: string;
  onChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const Select: FC<SelectPropTypes> = memo(function Select(props) {
  const { options, error, children, value, className, ...other } = props;
  const { formatMessage } = useIntl();
  return (
    <select
      {...other}
      className={classNames(
        'outline-none rounded border border-solid border-input-border p-2 pr-5 bg-input-bg text-input-text text-base',
        error && 'border-red-400',
        className,
      )}
      value={value}
    >
      {options.map(({ label, value: option, disabled }) => (
        <option key={`${label}-${option}`} value={option} disabled={disabled}>
          {typeof label === 'string' ? label : formatMessage(label)}
        </option>
      ))}
      {children}
    </select>
  );
});
